// extracted by mini-css-extract-plugin
export default {"div_select_company":"selecao_div_select_company__8UgqG","select_company":"selecao_select_company__Si6gd","div_header_empresa":"selecao_div_header_empresa__ZiGJu"};